import { reactive } from 'vue'

/**
 * Лёгкая тост-система: одна точка истины (массив сообщений в reactive
 * state), компонент `AppToast.vue` его рендерит, любые места кода
 * добавляют сообщения через `useToast().push(...)`.
 *
 * Зачем своя: ставить «полноценную» тостер-либу ради 50 строк UI —
 * излишне; глобальный `alert()` блокирует поток и выглядит плохо на
 * мобильных. Этот вариант неинвазивный и подключается одним <AppToast/>
 * в `AppLayout.vue`.
 */

export type ToastLevel = 'info' | 'success' | 'error'

export interface Toast {
  id: number
  level: ToastLevel
  text: string
  /** Когда тост сам исчезнет, мс с момента добавления. */
  ttl: number
}

const state = reactive<{ items: Toast[] }>({ items: [] })

let _idSeq = 1

function push(level: ToastLevel, text: string, ttl = 5000): void {
  const id = _idSeq++
  state.items.push({ id, level, text, ttl })
  if (ttl > 0) {
    setTimeout(() => dismiss(id), ttl)
  }
}

function dismiss(id: number): void {
  const idx = state.items.findIndex((t) => t.id === id)
  if (idx !== -1) state.items.splice(idx, 1)
}

export function useToast() {
  return {
    items: state.items,
    info: (text: string, ttl?: number) => push('info', text, ttl),
    success: (text: string, ttl?: number) => push('success', text, ttl),
    error: (text: string, ttl?: number) => push('error', text, ttl ?? 8000),
    dismiss,
  }
}
